import { render, staticRenderFns } from "./KanbanLayout.vue?vue&type=template&id=4eac2a76&scoped=true"
import script from "./KanbanLayout.vue?vue&type=script&lang=js"
export * from "./KanbanLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eac2a76",
  null
  
)

export default component.exports